import React, { useEffect, useRef, useState } from "react";
import ResourceList from "../component/resources/resourceList";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import * as resourceAction from "../../../redux/actions/resourceAction";
import { useDispatch, useSelector } from "react-redux";
import * as clientAction from "../../../redux/actions/clientAction";
import * as assetsAction from "../../../redux/actions/assetsAction";
import {
  API_STATUS,
  LOGIN_ORG_ID,
  ORG_ID,
  PAGE_SIZE,
  ORG_NAME,
} from "../../../constant/constant";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ACCESS_DENIED,
  ADMIN_ADD_RESOURCE,
  ADMIN_EDIT_RESOURCE,
  ADMIN_RESOURCE,
  ADMIN_SW_VIEW_PROJECT,
} from "../../../constant/routeContant";
import { PRODUCT_ID } from "../../../constant/storm-water/constant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { toast, ToastContainer } from "react-toastify";
import { InactiveClient } from "../../../utils/helper";
import { getPreviousRoute } from "../../../utils/routeTracker";
export default function ResourceContainer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const projectId = location?.state?.projectId;
  const projectName = location?.state?.projectName;
  const customerId = location?.state?.customerId;
  const customerName = location?.state?.customerName;
  const isEntryFromProject =
    customerId !== undefined &&
    customerId !== null &&
    customerId !== "" &&
    projectId !== undefined &&
    projectId !== null &&
    projectId !== "";
  const [sendEmail, setSendEmail] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const resources = useSelector((state) => state.resourceList);
  const [clientsValue, setClientsValue] = useState({
    key: customerId ?? "",
    value: customerName ?? "",
  });

  const [projectvalue, setProjectValue] = useState({
    key: projectId ?? "",
    value: projectName ?? "",
  });

  const clientsValueRef = useRef({
    key: customerId ?? "",
    value: customerName ?? "",
  });
  const projectValueRef = useRef({
    key: projectId ?? "",
    value: projectName ?? "",
  });
  useEffect(() => {
    clientsValueRef.current = clientsValue;
  }, [clientsValue]);
  useEffect(() => {
    projectValueRef.current = projectvalue;
  }, [projectvalue]);

  const defaultData = {
    page: 1,
    pageSize: PAGE_SIZE,
    resourceTypes: "",
    startDate: "",
    endDate: "",
    catId: 0,
    search: "",
    userId: 0,
    orgId: customerId ? customerId : parseInt(ORG_ID()),
    assetId: projectId ? projectId : 0, // assetId is project id
    assetTypeId: parseInt(PRODUCT_ID()) === 2 ? 5 : 0, // assetTypeId ==5 for storm water ,0 for safety
    isSendMail: false,
  };

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [ADMIN_RESOURCE, ADMIN_EDIT_RESOURCE];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("resourceListPreserveState") === "true";
    sessionStorage.removeItem("resourceListPreserveState");

    dispatch(resourceAction.clearResource());
    if (!isFromPreserveRoute && !isEntryFromProject) {
      dispatch(resourceAction.getResourceFilterObj(null));
    }

    if (isEntryFromProject) {
      setShouldRestoreState(false);
      const entryClient = { key: customerId ?? "", value: customerName ?? "" };
      const entryProject = { key: projectId ?? "", value: projectName ?? "" };
      dispatch(
        resourceAction.getResourceFilterObj({
          ...defaultData,
          orgData: entryClient.value,
          clientsValueKey: entryClient,
          projectKeyValue: entryProject,
          projectdata: entryProject.value,
        }),
      );
      getResourceListData(defaultData, false);
      return;
    }
    if (isFromPreserveRoute && resources?.filterObj) {
      setShouldRestoreState(true);
      getResourceListData(resources.filterObj, false);
    } else {
      setShouldRestoreState(false);
      getResourceListData(defaultData, false);
    }
  }, []);

  useEffect(() => {
    if (customerId && projectName) {
      dispatch(
        assetsAction.getAssetDynomoList({
          searchText: String(projectName || "").trim(),
          type: 5,
          orgId: customerId,
        }),
      );
    }
  }, [customerId, projectName]);

  const getResourceListData = (data, filtobj, keyData, whichOnChnage) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(resourceAction.getResourceList(data));
    if (!filtobj) return;

    const curClient = clientsValueRef.current;
    const curProject = projectValueRef.current;

    let newClientKey, newProjectKey;

    if (whichOnChnage) {
      newClientKey = curClient?.key ? curClient : null;
      newProjectKey = keyData !== undefined ? keyData : null;
    } else if (keyData !== undefined) {
      newClientKey = keyData;
      newProjectKey = null;
    } else {
      newClientKey = curClient?.key ? curClient : null;
      newProjectKey = curProject?.key ? curProject : null;
    }

    const updateData = {
      ...data,
      orgData: newClientKey?.value ?? "",
      clientsValueKey: newClientKey,
      projectKeyValue: newProjectKey,
      projectdata: newProjectKey?.value ?? "",
    };
    dispatch(resourceAction.getResourceFilterObj(updateData));
  };
  const filterObjHandle = (data) => {
    dispatch(resourceAction.getResourceFilterObj(data));
  };

  const addResource = () => {
    if (InactiveClient()) return;
    navigate(ADMIN_ADD_RESOURCE, {
      state: { addMode: true },
    });
  };
  const allProject = useSelector((state) => state.getAssetDynomoList);
  const isProjectLoading = allProject?.isLoading;

  const deleteResource = useSelector((state) => state.deleteResource);
  useEffect(() => {
    if (deleteResource?.status === API_STATUS.SUCCESS) {
      if (resources?.filterObj) {
        getResourceListData(resources.filterObj, false);
      } else {
        getResourceListData(defaultData, false);
      }
    }
  }, [deleteResource]);
  const handleDeleteOnClick = (resourceId) => {
    if (InactiveClient()) return;
    dispatch(resourceAction.deleteResource(resourceId));
  };
  const hbnextdata = {
    key: parseInt(ORG_ID()),
    value: ORG_NAME(),
  };
  const handleEditOnClick = (row) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("resourceListPreserveState", "true");
    navigate(ADMIN_EDIT_RESOURCE, {
      state: {
        resourceId: row?.id,
        resourceType: row?.resourceTypeId,
        editMode: true,
        clientsValue: clientsValue.key ? clientsValue : hbnextdata,
      },
    });
  };

  const viewProjectOnClick = (row) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("resourceListPreserveState", "true");
    navigate(ADMIN_SW_VIEW_PROJECT, {
      state: {
        projectid: row?.projectId,
        customerId: row?.customerId,
        customerName: row?.customerName,
        editMode: true,
        clients: row?.customerId,
        projectName: row?.projectName,
      },
    });
  };

  const isLoading = useSelector(
    (state) => resources?.isLoading || state.deleteResource?.isLoading,
  );

  const resourceCategory = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.resourceCategories,
  );
  const resourceType = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.resourceTypes,
  );
  useEffect(() => {
    const getDropdownDataKeyValueData = {
      orgId: LOGIN_ORG_ID() === ORG_ID() ? LOGIN_ORG_ID() : ORG_ID(),
      flags: [14, 15],
      productId: PRODUCT_ID(),
    };
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);

  const searchAllClientsReducerData = useSelector(
    (state) => state.searchAllClientsReducerData,
  );
  const autoSearchDataLoading = searchAllClientsReducerData.isLoading;
  const searchClient = (searchText) => {
    dispatch(clientAction.searchAllClients(searchText));
  };

  function handleAllProjectSearch(event, value, customerId) {
    const inputValue = String(event.target?.value || "").trim();
    if (inputValue) {
      dispatch(
        assetsAction.getAssetDynomoList({
          searchText: inputValue,
          type: 5,
          orgId: customerId,
        }),
      );
    }
  }

  useEffect(() => {
    if (resources?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Resource has been sent to registered email ID");
    }
  }, [resources]);

  return (
    <>
      {checkPrivileges([12, 73, 74, 75, 139]) ? (
        <>
          <ToastContainer />
          <ResourceList
            isLoading={isLoading}
            resources={isLoading ? [] : resources?.data?.result}
            getResourceListData={getResourceListData}
            addResource={addResource}
            isShow={true}
            filterShow={true}
            handleDeleteOnClick={handleDeleteOnClick}
            handleEditOnClick={handleEditOnClick}
            resourceCategory={resourceCategory}
            resourceType={resourceType}
            searchClient={searchClient}
            autoSearchDataLoading={autoSearchDataLoading}
            searchAllClientsReducerData={searchAllClientsReducerData}
            isProjectLoading={isProjectLoading}
            allProjects={allProject?.data}
            handleAllProjectSearch={handleAllProjectSearch}
            setClientsValue={setClientsValue}
            clientsValue={clientsValue}
            isShowDowdownloadButton={true}
            resourcesdata={resources}
            setProjectValue={setProjectValue}
            filterObjHandle={filterObjHandle}
            shouldRestoreState={shouldRestoreState}
            customerName={customerName}
            customerId={customerId}
            projectName={projectName}
            projectId={projectId}
            viewProjectOnClick={viewProjectOnClick}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}
